import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { getClanLeaderboard } from '../../client/api/server_api.js';
import Leaderboard from './../Leaderboard/Leaderboard.js';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs.js';
import ClanStats from '../ClanStats/ClanStats.js';

function Routing() {
    return(
        <div className="clanleaderboard_container">
            <BrowserRouter>
                <Switch>
                    <Route exact path="/:lang/clanleaderboard/clans/" component={Leaderboard}/>
                    <Route exact path="/:lang/clanleaderboard/clan/:clan_db_id" component={ClanStats}/>
                </Switch>
            </BrowserRouter>
        </div>
    );
}

export default Routing;
